import api from './api';

const service = {
  fetch: params => api.get('blacklists', params),
  fetchById: id => api.get(`blacklists/${id}`),
  blacklist: params => api.post('blacklists', params),
  unblacklist: id => api.delete(`blacklists/${id}`),
  update: blacklist => api.put(`blacklists/${blacklist.id}`, blacklist),
};

export default service;
